import { Logo } from "@/components/layout/Logo";

interface Props {
  title?: string;
  message?: string;
}

export default function ErrorPage({
  title = "Something went wrong",
  message = "An unexpected error occurred. Please try refreshing the page.",
}: Props) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm text-center">
        <div className="flex justify-center mb-10 h-10 text-brand-navy dark:text-white">
          <Logo />
        </div>
        <h1 className="text-xl font-semibold text-primary mb-2">{title}</h1>
        <p className="text-sm text-secondary">{message}</p>
      </div>
    </div>
  );
}
